import {useState} from 'react';

import {useDocumentUtils} from '@/components/document/utils';
import {useConfig} from '@/contexts/config';
import {DocumentModel, computeDocumentModel} from '@/engine';
import {createVisibilitySet} from '@/engine/document-model/utils';
import {DocumentStore} from '../store/document-store';
import {useSubscribeToStoreChange} from './use-subscribe-to-store-change';

export type UseDocumentModelProps = {
  onChanged?: (changedKeys: string[], state: DocumentStore) => void;
};

export type DocumentModelState = {
  documentModel: DocumentModel;
  visibilitySet: Set<string>;
};

export const useDocumentModel = ({onChanged}: UseDocumentModelProps) => {
  const {model} = useConfig();
  const {store, valueResolver} = useDocumentUtils();

  const [{documentModel, visibilitySet}, setState] = useState<DocumentModelState>(() => {
    const documentModel = computeDocumentModel(model, store, valueResolver);
    const visibilitySet = createVisibilitySet(documentModel);
    return {documentModel, visibilitySet};
  });

  const {ready} = useSubscribeToStoreChange(onChanged, setState);

  return {documentModel, visibilitySet, ready};
};
